import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl} from './Handler.js'
import store from '../store/index'
//#region  Gateway
export function _create(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}

export function _update(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _delete(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/${id}`;
    return axios.delete(url,config).then(_handleSuccess,_handleError)
}
export function _getById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
 
export function _search(model){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
    
}
export function _getAllGatewayCombo(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/all`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
 
//#endregion

 
//#region Transfer Config 

export function _createTransferConfiguration(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/transferConfiguration`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}

export function _updateTransferConfiguration(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/transferConfiguration`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _deleteTransferConfiguration(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/transferConfiguration/${id}`;
    return axios.delete(url,config).then(_handleSuccess,_handleError)
}
export function _getTransferConfigurationById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/transferConfiguration/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
 
export function _searchTransferConfiguration(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/transferConfiguration/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _updateNextScheduleTransferConfigurationById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/transferConfiguration/updateNextSchedule/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}

export function _getWaitingTransferConfiguration(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/transferConfiguration/getWaitng`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 

//#endregion
//#region TRansfer Configuration parameter


export function _createTransferConfigurationParameter(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/parameter`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}

export function _updateTransferConfigurationParameter(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/parameter`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _deleteTransferConfigurationParameter(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/parameter/${id}`;
    return axios.delete(url,config).then(_handleSuccess,_handleError)
}
export function _getTransferConfigurationParameterById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/parameter/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
 
export function _searchTransferConfigurationParameter(model){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/parameter/search`;
    return axios.get(url,model,config).then(_handleSuccess,_handleError)
} 
export function _getTransferConfigurationParameterByConfigurationId(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/parameter/configuration/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 

export function _updateTransferConfigurationParameters(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/parameter/updateParameters`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
//#endregion

//#region Transfer Configuration History


export function _createTransferConfigurationHistory(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/history`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}

export function _updateTransferConfigurationHistory(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/history`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _deleteTransferConfigurationHistory(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/history/${id}`;
    return axios.delete(url,config).then(_handleSuccess,_handleError)
}
export function _getTransferConfigurationHistoryById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/history/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
 
export function _searchTransferConfigurationHistory(model){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },params:model};
    const url = `${_getUrl()}/gateways/history/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _GetByTransferDataId(transferDataId){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' }};
    const url = `${_getUrl()}/gateways/transferData/${transferDataId}/history`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getTransferConfigurationHistoryByConfigurationId(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/history/getHistoriesByConfigurationId/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _createTransferConfigurationHistoryAndSetNext(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/history/createAndSetNext`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}
      
export function _getTransferStatus(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/types/status`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getTransferConnectors(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/types/connector`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getTransferTypes(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/types/transferType`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getTransferOperators(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/gateways/types/operators`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
//#endregion


//TransferData
export function _transferDataSearch(params){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },params:params};
    const url = `${_getUrl()}/gateways/transferData/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
    
}

//